import styled from '@emotion/styled';
import TableTab from './TableTab';
import HorizontalFlex from '../../../components/flex_layouts/HorizontalFlex';
import { useTableContext } from '../../../context/TableContext';
import { Text6 } from '../../../components/typography/Text6';
import { useAppContext } from '../../../context/AppContext';
import React, { forwardRef, Ref } from 'react';

const TableTabs = ({ ...props }, ref: React.ForwardedRef<HTMLDivElement>) => {
  const { tabs, selectedTabId, setSelectedTabId, applyPagination } = useAppContext();
  const { setCurrentPage } = useTableContext();

  const handleTabClick = (tabName: string) => {
    setSelectedTabId(tabName);
    setCurrentPage(1);
    (ref as React.MutableRefObject<HTMLDivElement>)?.current.scrollIntoView(true);
  };

  return (
    <LayoutRoot {...props}>
      <TitleContainer>
        <Text6>Biological process</Text6>
        <HorizontalFlex>
          <img src="/small-arrow-right.svg" alt="Arrow Right 1" />
          <img src="/small-arrow-right.svg" alt="Arrow Right 2" />
        </HorizontalFlex>
      </TitleContainer>
      <TabItemsContainer>
        {tabs
          .filter((tabName) => (applyPagination ? true : tabName === selectedTabId))
          .map((tabName) => (
            <TableTab
              key={tabName}
              text={tabName}
              isSelected={selectedTabId === tabName}
              onClick={() => handleTabClick(tabName)}
            />
          ))}
      </TabItemsContainer>
    </LayoutRoot>
  );
};

export default forwardRef(TableTabs);

const LayoutRoot = styled(HorizontalFlex)`
  gap: 10px;
  flex-wrap: wrap;

  @media (max-width: 450px) {
    flex-direction: column;
    gap: 16px;
  }
`;

const TabItemsContainer = styled(HorizontalFlex)`
  gap: 10px;
  flex-wrap: wrap;
`;

const TitleContainer = styled(HorizontalFlex)`
  align-items: center;
  gap: 8px;
`;
